import { getPanelOptions } from '../utils';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    groups: {

    },
    fields: {
        type: {
            section: 'details',
            noTitle: true,
            readonly: true,
            position: 0,
            section: 'details',
            component: RadioListComponent,
            values: function (value) {
                return getPanelOptions([value]);
            },
        },
        name: {
            section: 'details',
            position: 1,
        },
        title: {
            section: 'details',
            position: 2,
        },
        content: {
            section: 'details',
            position: 3,
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel-text-content.js